import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '@env/environment';

@Component({
  selector: 'hypenation-shared-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {
  get organiserLoginUrl(): string {
    return environment.organiserPortalUrl + '#/auth/login';
  }
}
